import { render } from "./sign.vue?vue&type=template&id=7b633e37&scoped=true&ts=true"
import script from "./sign.vue?vue&type=script&lang=ts"
export * from "./sign.vue?vue&type=script&lang=ts"

import "./sign.vue?vue&type=style&index=0&id=7b633e37&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b633e37"]])

export default __exports__